module.exports = __webpack_public_path__ + "img/2.374ff36a.png";